import { render, staticRenderFns } from "./AccountFlowTable.vue?vue&type=template&id=45b4471e&scoped=true&"
import script from "./AccountFlowTable.vue?vue&type=script&lang=js&"
export * from "./AccountFlowTable.vue?vue&type=script&lang=js&"
import style0 from "./AccountFlowTable.vue?vue&type=style&index=0&id=45b4471e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b4471e",
  null
  
)

export default component.exports